/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import FacebookLeadAdsForm from 'cio/models/facebook-lead-ads-form';
import CampaignModel, { FormTriggeredCampaignFormTriggerFilter } from 'cio/models/campaign';
import deserializeAndNormalizeFormAttributeFilters from 'cio/utils/campaigns/deserialize-normalize-form-attribute-filters';
import CustomForm from 'cio/models/custom-form';

interface FormsFormsTableArgs {
  campaigns: CampaignModel[];
  forms: (FacebookLeadAdsForm | CustomForm)[];

  connectFormAction: (f: FacebookLeadAdsForm | CustomForm | null, type: 'facebook' | 'custom') => unknown;
  disconnectFormAction: (f: FacebookLeadAdsForm | CustomForm | null, type: 'facebook' | 'custom') => unknown;

  showFormsEndpointAction: () => unknown;
  showJSSnippetAction: () => unknown;
  showHTMLAttributeAction: () => unknown;
  showTypeformAction: () => unknown;
  showJotformAction: () => unknown;
}

export default class FormsFormsTable extends Component<FormsFormsTableArgs> {
  logoColorImage = new URL('cio/assets/images/logo-color.svg', import.meta.url).toString();

  get formsForDisplay() {
    return this.args.forms.map((f) => ({
      form: f,
      campaigns: this.args.campaigns.filter((c) => {
        // handle draft form campaigns without selected triggers (no "attributeFilters")
        if (!c.attributeFilters) {
          return false;
        }

        return deserializeAndNormalizeFormAttributeFilters(c.attributeFilters).children.some(
          (c: FormTriggeredCampaignFormTriggerFilter) =>
            c.children[0].value === (f instanceof FacebookLeadAdsForm ? f.facebookFormId : f.formIdLowercase),
        );
      }),
    }));
  }
}
